import { codePanelDispatch, CodePanelActions } from '../../contexts/CodePanelContext'

async function presentSharedFileTabs() {
  await codePanelDispatch({ type: CodePanelActions.UPDATE_SHARED_FILES_TABS })
}

export { presentSharedFileTabs }